export default __webpack_public_path__ + "static/media/add.73fde143.svg";